import RestService from './RestService';

export default class Branding extends RestService {
    constructor(parentService, parentId) {
        if (parentService && parentId) {
            super(`${parentService.baseUrl}/${parentId}/branding`);
        } else super('/branding');
    }
}
